import React from "react";
import CommonComponents from "../../../components/common/CommonComponents";
import useMember from "../../../data-access/useMember";

const Thinktank = () => {
  const { member, memberLoading } = useMember({ type: "think_tank" });

  return (
    <div className="flex flex-col gap-12">
      {member?.map((mem, i) => (
        <CommonComponents
          order={i % 2 !== 0}
          heading={mem?.name}
          data={mem?.description}
          img={mem?.image?.[0]}
        />
      ))}
    </div>
  );
};

export default Thinktank;
